import axios from 'axios'
import * as types from '../mutation-types'

// state
export const state = {
  users: null
}

// getters
export const getters = {
  users: state => state.users
}

// mutations
export const mutations = {
  [types.DELETE_USERS] (state, ids) {
    for (let id of ids) {
      const index = state.users.findIndex(u => u.id == id)
      if (index >= 0) {
        state.users.removeAt(index)
      }
    }
  },

  [types.FETCH_USERS_SUCCESS] (state, { users }) {
    state.users = users
  },

  [types.FETCH_USERS_FAILURE] (state) {

  },

  [types.UPDATE_USER] (state, { user }) {
    const index = state.users.findIndex(u => u.id == user.id)
    if (index >= 0) {
      state.users.splice(index, 1, user)
    } else {
      state.users.push(user)
    }
  }
}

// actions
export const actions = {
  saveToken ({ commit, dispatch }, payload) {
    commit(types.SAVE_TOKEN, payload)
  },

  async fetchUsers ({ dispatch, commit }) {
    try {
      const { data } = await axios.get('/api/users')

      commit(types.FETCH_USERS_SUCCESS, { users: data })
    } catch (e) {
      commit(types.FETCH_USERS_FAILURE)
    }
  },

  async deleteUsers ({ commit, dispatch, rootState }, ids) {
    try {
      const { data } = await axios.delete('/api/users', { data: { 'ids': ids } })

      commit(types.DELETE_USERS, ids)

      // If user has removed itself, logout.
      if (ids.includes(rootState.auth.user.id)) {
        await dispatch('auth/logout', null, { root: true })
      }
    } catch (e) {

    }
  },

  storeUser ({ commit }, payload) {
    commit(types.UPDATE_USER, payload)
  },

  updateUser ({ commit }, payload) {
    commit(types.UPDATE_USER, payload)
  }
}



// WEBPACK FOOTER //
// ./resources/js/store/modules/users.js